// extracted by mini-css-extract-plugin
module.exports = {"button":"AvatarLine_button__3JzY5","full-width-avatar":"AvatarLine_full-width-avatar__pJTrc","mainContent":"AvatarLine_mainContent__3uhG-","avatar":"AvatarLine_avatar__3OFrV"};